export class SetAccessTokenAction {
  static readonly type = '[Session] Set access token';
  constructor(public accessToken: string) {}
}

export class RemoveAccessTokenAction {
  static readonly type = '[Page] Remove access token';
  constructor() {}
}
